<!-- 
<div class="article-list-title">
    <span *ngIf="!authorMode || !authorName">Recent Articles</span>
    <span *ngIf="authorMode && authorName">Articles by {{ authorName }}</span>
</div> -->

<div class="article-list" *ngIf="!blogLoading && !blogError && blogArticles.length > 0">
    <ng-container *ngFor="let article of blogArticles | paginate
        : {
            itemsPerPage: blogPageSize,
            currentPage: blogInputPage,
            totalItems: totalPostCount
        }; index as i"
    >
        <div class="article-link" routerLink="/news/{{ article.slug }}">
            <app-article-image-container
                class="article-image standard"
                imageSrc="{{ article.thumbnail.dynamic_url }}?w=300"
                [lazy]="i !== 0"
            ></app-article-image-container>
            <app-article-image-container
                class="article-image square"
                [square]="true"
                imageSrc="{{ article.thumbnail.dynamic_url }}?w=240"
                [lazy]="i !== 0"
            ></app-article-image-container>
            <div class="article-summary">
                <div class="article-info">
                    <div class="article-author">
                        <span *ngIf="article.authors?.length">
                            <span *ngFor="let author of article.authors; last as last">
                                {{ author.first_name }} {{ author.last_name }}{{ !last ? ', ' : '' }}
                            </span>
                        </span>
                        <span *ngIf="!article.authors?.length">
                            {{ article.author }}
                        </span>
                    </div>
                    <div class="article-date"> {{ article.published_date | date : "MMM d, yyyy"}}</div>
                </div>
                <a routerLink="/news/{{ article.slug }}">
                    <div class="article-text">
                        <div class="article-title">{{ article.title }}</div>
                        <!-- <div class="article-preview">{{ article.summarized_description }}</div> -->
                        <!-- <div class="article-time-author">
                            <span>{{ article.author }}</span> -
                            <span class="lighten">{{ article.published_date_readable }}</span>
                        </div> -->
                        
                        <!-- <span class="read-more-cta">READ MORE <fa-icon [icon]="faAngleRight"></fa-icon></span> -->
                    </div>
                </a>
            </div>
        </div>

        <app-display-ad type="horseracing-POS1" class="small-only" [largeOnly]="true" *ngIf="i === 2 && (category | uppercase) === 'RACING' && (environment.googleAdsConfig?.adSpaces?.['horseracing-POS1'] || environment.optionalFeatures.includes('placeholder-ads'))"></app-display-ad>
        <app-display-ad type="horseracing-POS2" class="small-only" [largeOnly]="true" *ngIf="i === 5 && (category | uppercase) === 'RACING' && (environment.googleAdsConfig?.adSpaces?.['horseracing-POS2'] || environment.optionalFeatures.includes('placeholder-ads'))"></app-display-ad>
	
        
    </ng-container>
</div>
<div  class="pagination" *ngIf="!blogLoading && !blogError && blogArticles.length > 0" >
    <pagination-template #p="paginationApi" (pageChange)="setBlogPage($event)">
        <div class="custom-pagination">
            <div class="pagination-previous" >
                <a class="page-button previous" [class.disabled]="currentPage <= 0" routerLink="./"
                    [queryParams]="{page: isValidPageNumber(currentPage) ? (currentPage === 1 ? undefined : currentPage) : currentPage + 1}" queryParamsHandling="merge">
                    <fa-icon [icon]="faAngleLeft"></fa-icon>
                </a>
            </div>
    
            <div *ngFor="let page of p.pages" [class.current]="p.getCurrent() === page.value">
                <a (click)="p.setCurrent(page.value)" *ngIf="p.getCurrent() !== page.value">
                    <span>{{ page.label }}</span>
                </a>
                <div *ngIf="p.getCurrent() === page.value">
                    <span>{{ page.label }}</span>
                </div>
            </div>
    
            <div class="pagination-next" [class.disabled]="p.isLastPage()">
                <a class="page-button next" [class.disabled]="currentPage >= numberOfPages() - 1" routerLink="./"
                    [queryParams]="{page: isValidPageNumber(currentPage + 2) ? currentPage + 2 : currentPage + 1}" queryParamsHandling="merge">
                    <fa-icon [icon]="faAngleRight"></fa-icon>
                </a>
            </div>
        </div>
    </pagination-template>
    <div class="pagination-input">
        Go to page: 
        <input type="number" [(ngModel)]="blogInputPage"/>
        <div *ngIf="isValidPageNumber(blogInputPage)"
            (click)="setBlogPage(blogInputPage)" class="go-to-page">
            Go
        </div>
    </div>
</div>

<!-- <div *ngIf="!blogLoading && !blogError && blogArticles.length > 0">
    <pagination-controls 
    class="my-pagination"
    (pageChange)="setBlogPage($event)"   
    previousLabel=">"
    nextLabel="<"
    
    ></pagination-controls>
    <div class="page-input">
        <input type="number" [(ngModel)]="blogInputPage"/>
        <div *ngIf="isValidPageNumber(blogInputPage)"
            (click)="setBlogPage(blogInputPage)" class="go-to-page">
            Go
        </div>
    </div>
</div> -->


<div class="blog-loading" *ngIf="blogLoading && !blogError">
    Loading...
</div>
<div class="blog-loading" *ngIf="blogError">
    <span>Sorry, something went wrong. Please <span class="retry-link" (click)="getArticles()">try again</span>.</span>
</div>
<div class="blog-loading" *ngIf="!blogLoading && !blogError && blogArticles.length === 0">
    No posts available
</div>
<!-- <div class="page-controls" *ngIf="!blogLoading && !blogError && blogArticles.length > 0">
    
        Next Button - goes to the previous page, unless page doesn't exist in which case button keeps user on same page
        (because of the zero-indexing being converted to one-indexing, previous page's query param is same number as current page's index
        - also for meta consistency, page 1 has no query parameter set)
   
    <a class="page-button previous" [class.disabled]="currentPage <= 0" routerLink="./"
        [queryParams]="{page: isValidPageNumber(currentPage) ? (currentPage === 1 ? undefined : currentPage) : currentPage + 1}" queryParamsHandling="merge">
        <fa-icon [icon]="faAngleLeft"></fa-icon>
    </a>


    Text Page Input - allows user to select a page number and then immediately navigate to that page (if it exists)
    <div class="page-input">
        <input type="number" [(ngModel)]="blogInputPage"/>
        <div *ngIf="isValidPageNumber(blogInputPage)"
            (click)="setBlogPage(blogInputPage)" class="go-to-page">
            Go
        </div>
    </div>
    <div class="page-label">
        <span>of&nbsp;{{ numberOfPages() }}</span>
    </div>
    
        Next Button - goes to the next page up, unless page doesn't exist in which case button keeps user on same page
        (because of the zero-indexing being converted to one-indexing, next page's query param is two larger than current page's index)
   
    <a class="page-button next" [class.disabled]="currentPage >= numberOfPages() - 1" routerLink="./"
        [queryParams]="{page: isValidPageNumber(currentPage + 2) ? currentPage + 2 : currentPage + 1}" queryParamsHandling="merge">
        <fa-icon [icon]="faAngleRight"></fa-icon>
    </a>
</div> -->

